import { apiFetch } from '@/lib/api';

export interface ScheduledJob {
  id: string;
  job_type: string;
  enabled: boolean;
  schedule_cron: string;
  metadata: {
    max_items_to_fetch?: number;
    staleness_days?: number;
    [key: string]: any;
  };
  last_run_at: string | null;
  last_run_status: 'success' | 'failed' | null;
  last_run_error: string | null;
  created_at: string;
  updated_at: string;
}

export interface ScheduledJobUpdateInput {
  enabled?: boolean;
  schedule_cron?: string;
  metadata?: Record<string, any>;
}

export class ScheduledJobsService {
  /**
   * List all scheduled jobs
   */
  async list(): Promise<ScheduledJob[]> {
    const response = await apiFetch('/api/admin/scheduled-jobs');
    const json = await response.json() as { success: boolean; data: ScheduledJob[] };
    return json.data;
  }

  /**
   * Get a single scheduled job by ID
   */
  async getById(id: string): Promise<ScheduledJob> {
    const response = await apiFetch(`/api/admin/scheduled-jobs/${id}`);
    const json = await response.json() as { success: boolean; data: ScheduledJob };
    return json.data;
  }

  /**
   * Update scheduled job configuration
   */
  async update(id: string, config: ScheduledJobUpdateInput): Promise<void> {
    await apiFetch(`/api/admin/scheduled-jobs/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(config)
    });
  }
}

